import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=438d0684&scoped=true"
import script from "./SectionHero.vue?vue&type=script&lang=ts"
export * from "./SectionHero.vue?vue&type=script&lang=ts"
import style0 from "./SectionHero.vue?vue&type=style&index=0&id=438d0684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d0684",
  null
  
)

export default component.exports